import React, { Component } from "react";
import { observer, inject } from "mobx-react";

import { Select, MenuItem, Grid, IconButton, Button } from "@material-ui/core";

import MomentUtils from "@date-io/moment";
import moment from "moment";
import _ from "lodash";

import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import LoadingSpinnerElement from "../loadingSpinner/loadingSpinnerElement"
import "./AgentFilter.css";
import { Promise } from "bluebird";
import { BookingType } from "../../types/enum";
import SelectField from "../fields/SelectField";

const dateFormat = "DD-MM-YYYY";
const monthFormat = "MMM YYYY";

@inject("profileStore", "venueStore", "agentFilterStore", "agentActStore", "agentVenueStore")
@observer
class AgentFilter extends Component {
    postChangeInterval = undefined;

    constructor(props) {
        super(props);
        this.state = {
            dashboardFilter: "monthly",
            showDateRangePicker: false,
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
            venues: [],
            acts: [],
            actsLoading: true,
            venuesLoading: true,
            actsError: false,
            venuesError: false
        };
    }    

    componentDidMount() {
        this.mounted = true;
        if (this.props.filterSection !== "date") {
            this.props.agentFilterStore.resetFilterData();
            this.props.agentActStore.resetAgentActs();
            this.loadOptions();
        }
    }
    componentDidUpdate() {
        if (this.props.filterSection !== "date" &&
            String(this.getProfileId()) !== String(this.optionsProfileId)) {
            this.loadOptions();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.postChangeInterval) {
            clearInterval(this.postChangeInterval);
        }
    }

    getProfileId = () => {
        const store = this.props.profileStore;
        return (store.currentProfile || store.getCurrentProfile())?.id;
    };

    loadOptions = () => {
        const profileId = this.getProfileId();
        this.optionsProfileId = profileId;
        const request = this.optionsRequest = (this.optionsRequest || 0) + 1;
        const isCurrent = () => this.mounted && request === this.optionsRequest &&
            String(profileId) === String(this.getProfileId());
        this.setState({
            acts: [], venues: [], actsLoading: true, venuesLoading: true,
            actsError: false, venuesError: false
        });
        if (!profileId) {
            this.setState({
                actsLoading: false, venuesLoading: false,
                actsError: true, venuesError: true
            });
            return;
        }
        Promise.all([
            Promise.try(() => this.props.agentActStore.getAgentActRosterForMyGigs(profileId)),
            Promise.try(() => this.props.agentActStore.getAgentMyActsForMyGigs(profileId))
        ]).then(([roster, myActs]) => {
            if (isCurrent()) {
                this.mapActToSuggestions([...roster, ...myActs]);
            }
        }).catch(() => {
            if (isCurrent()) {
                this.setState({ actsLoading: false, actsError: true });
            }
        });
        Promise.try(() => this.props.agentVenueStore.getAgentVenueSimple(profileId))
            .then(venues => {
                if (isCurrent()) {
                    this.mapVenuesToSuggestions(venues);
                    this.setState({ venuesLoading: false });
                }
            }).catch(() => {
                if (isCurrent()) {
                    this.setState({ venuesLoading: false, venuesError: true });
                }
            });
    };

    mapActToSuggestions = actRosters => {
        const acts = _.uniqBy(
            actRosters.map(row => row.act),
            act => String(act.id)
        );

        acts.sort((a, b) => {
            const first = a.actNameString || String(a.actName || "").toUpperCase();
            const second = b.actNameString || String(b.actName || "").toUpperCase();
            return first < second ? -1 : first > second ? 1 : 0;
        });

        this.setState({
            acts,
            actsLoading: false
        });
    };

    mapVenuesToSuggestions = venueRosters => {
        let venues = [];
        venueRosters.forEach(venueRoster => {
            if(!venues.find(x => x.id === venueRoster.venueId)){
                venues.push(venueRoster.venue);
            }
        });

        venues.sort((a, b) => (a.profileNameString < b.profileNameString ? -1 : 1))

        this.setState({
            ...this.state,
            venues: venues
        })
    };

    postFilterChange = () => {
        const { venueFilter, startDate, endDate, actFilter, bookingType, dayOfWeekFilter } = this.props.agentFilterStore;
        var filterData = {
            venue: venueFilter,
            startDate: startDate,
            endDate: endDate,
            act: actFilter,
            bookingType: bookingType,
            dayOfWeek: dayOfWeekFilter
        };

        if (this.postChangeInterval) {
            clearInterval(this.postChangeInterval);
        }

        this.postChangeInterval = setInterval(() => {
            this.props.postChangeEvent(filterData);
            clearInterval(this.postChangeInterval);
        }, 1000);
    };

    onChange = e => {
        this.props.agentFilterStore.setFilterType(e.target.value);
        this.triggerFilterChangeImmediate();
    };

    onChangeAct = value => {
        const numericValue = value === "" || value === null || value === undefined ? 0 : Number(value);
        this.props.agentFilterStore.setActFilter(numericValue);
        this.triggerFilterChangeImmediate();
    }

    onChangeBookingType = value => {
        this.props.agentFilterStore.setBookingType(value);
        this.triggerFilterChangeImmediate();
    }

    onChangeDayOfWeek = value => {
        this.props.agentFilterStore.setDayOfWeekFilter(value);
        this.triggerFilterChangeImmediate();
    }

    mapDayOfWeekOptions = () => {
        return [
            { value: null, label: "All Days" },
            { value: 1, label: "Monday" },
            { value: 2, label: "Tuesday" },
            { value: 3, label: "Wednesday" },
            { value: 4, label: "Thursday" },
            { value: 5, label: "Friday" },
            { value: 6, label: "Saturday" },
            { value: 0, label: "Sunday" }
        ];
    }

    onVenueChange = value => {
        const numericValue = value === "" || value === null || value === undefined ? 0 : Number(value);
        this.props.agentFilterStore.setVenueFilter(numericValue);
        this.triggerFilterChangeImmediate();
    };

    onChangeStartDate = value => {
        const { endDate } = this.props.agentFilterStore;
        this.props.agentFilterStore.setStartDate(value);
        if (moment(value).endOf("day") > moment(endDate).endOf("day")) {
            this.props.agentFilterStore.setEndDate(value);
        }

        this.triggerFilterChangeImmediate();
    };

    onChangeEndDate = value => {
        const { startDate } = this.props.agentFilterStore;
        this.props.agentFilterStore.setEndDate(value);
        if (moment(value).endOf("day") < moment(startDate).endOf("day")) {
            this.props.agentFilterStore.setStartDate(value);
        }
        this.triggerFilterChangeImmediate();
    };

    onChangeMonth = value => {
        const startDate = moment(value).date(1);
        this.props.agentFilterStore.setStartDate(startDate);

        const endDate = moment(value).date(moment(value).daysInMonth());
        this.props.agentFilterStore.setEndDate(endDate);

        this.triggerFilterChangeImmediate();
    };

    onPrevMonth = () => {
        const { startDate } = this.props.agentFilterStore;
        const prevMonth = moment(startDate).subtract(1, 'month');
        this.onChangeMonth(prevMonth);
    };

    onNextMonth = () => {
        const { startDate } = this.props.agentFilterStore;
        const nextMonth = moment(startDate).add(1, 'month');
        this.onChangeMonth(nextMonth);
    };

    triggerFilterChangeImmediate = () => {
        const { venueFilter, startDate, endDate, actFilter, bookingType, dayOfWeekFilter } = this.props.agentFilterStore;
        var filterData = {
            venue: venueFilter,
            startDate: startDate,
            endDate: endDate,
            act: actFilter,
            bookingType: bookingType,
            dayOfWeek: dayOfWeekFilter
        };
        if (this.postChangeInterval) {
            clearInterval(this.postChangeInterval);
        }
        this.props.postChangeEvent(filterData);
    };

    mapActSuggestions = () => {
        const { acts } = this.state;
        let suggestions = [{
            value: 0,
            label: "All Acts"
        }];

        acts.forEach(act => {
            suggestions.push({
                value: act.id,
                label: act.actName
            })
        })

        return suggestions;
    }

    mapBookingType = () => {
        return [{
                value: undefined,
                label: "All"
            },{
                value: BookingType.Normal.ordinal,
                label: "Venue Booking"
            },{
                value: BookingType.Adhoc.ordinal,
                label: "Function Booking"
            }
        ];
    }
    mapVenues = () => {
          const { venues } = this.state;
            let suggestions = [{
                value: 0,
                label: "All Venues"
            }];

            venues.forEach(venue => {
                suggestions.push({
                    value: venue.id,
                    label: venue.profileName
                })
            })

            return suggestions;
    }

    handleBookingTypeChange = (e) => {
        const value = e.target.value === "" ? undefined : Number(e.target.value);
        this.onChangeBookingType(value);
    };


    handleActFilterChange = (e) => {
        const value = e.target.value;
        this.onChangeAct(value === 0 || value === "" ? 0 : Number(value));
    };

    handleVenueFilterChange = (e) => {
        const value = e.target.value;
        this.onVenueChange(value === 0 || value === "" ? 0 : Number(value));
    };

    renderEntityFilters = () => {
        const { venueFilter, actFilter, bookingType } = this.props.agentFilterStore;
        const { showActFilter } = this.props;
        const actSuggestions = this.mapActSuggestions();
        const venueSuggestions = this.mapVenues();

        return (
            <>
                <Select
                    className="dark-select slim-input"
                    value={bookingType !== undefined ? bookingType : ""}
                    onChange={this.handleBookingTypeChange}
                    displayEmpty
                    classes={{
                        root: "text-white",
                        icon: "text-white"
                    }}
                >
                    <MenuItem value="">All Booking Types</MenuItem>
                    <MenuItem value={BookingType.Normal.ordinal}>Venue Booking</MenuItem>
                    <MenuItem value={BookingType.Adhoc.ordinal}>Function Booking</MenuItem>
                </Select>
                {showActFilter && (
                    <SelectField
                        suggestions={actSuggestions}
                        onChange={this.onChangeAct}
                        value={actFilter !== undefined && actFilter !== null ? actFilter : 0}
                        placeholder="Select Act"
                        disabled={this.state.actsLoading || this.state.actsError}
                        paginated={this.props.paginatedActFilter}
                        pageSize={20}
                        color='#A9A9A9'
                        classes={{
                            root: "pull-right dark-select slim-input",
                            icon: "text-white",
                            input: "text-primary"
                        }}
                    />
                )}
                <SelectField
                    suggestions={venueSuggestions}
                    onChange={this.onVenueChange}
                    value={venueFilter !== undefined && venueFilter !== null ? venueFilter : 0}
                    placeholder="Select Venue"
                    disabled={this.state.venuesLoading || this.state.venuesError}
                    paginated={this.props.paginatedVenueFilter}
                    pageSize={20}
                    color='#A9A9A9'
                    classes={{
                        root: "pull-right dark-select slim-input",
                        icon: "text-white",
                        input: "text-primary"
                    }}
                />
                {(this.state.actsError || this.state.venuesError) && (
                    <div role="alert">
                        Could not load {this.state.actsError && this.state.venuesError
                            ? "Act and Venue filters" : this.state.actsError ? "Act filters" : "Venue filters"}.
                        <Button onClick={this.loadOptions} color="primary">Retry filters</Button>
                    </div>
                )}
            </>
        );
    };

    handleDayOfWeekChange = (e) => {
        const value = e.target.value === "" ? null : Number(e.target.value);
        this.onChangeDayOfWeek(value);
    };

    renderDateFilters = () => {
        const { filterType, startDate, endDate, dayOfWeekFilter } = this.props.agentFilterStore;

        return (
            <>
                <Select
                    className="dark-select slim-input"
                    value={dayOfWeekFilter !== null ? dayOfWeekFilter : ""}
                    onChange={this.handleDayOfWeekChange}
                    displayEmpty
                    classes={{
                        root: "text-white",
                        icon: "text-white"
                    }}
                >
                    <MenuItem value="">All Days</MenuItem>
                    <MenuItem value={1}>Monday</MenuItem>
                    <MenuItem value={2}>Tuesday</MenuItem>
                    <MenuItem value={3}>Wednesday</MenuItem>
                    <MenuItem value={4}>Thursday</MenuItem>
                    <MenuItem value={5}>Friday</MenuItem>
                    <MenuItem value={6}>Saturday</MenuItem>
                    <MenuItem value={0}>Sunday</MenuItem>
                </Select>
                <Select
                    label="Filter"
                    className="dark-select slim-input"
                    value={filterType}
                    onChange={this.onChange}
                    inputProps={{
                        color: "primary"
                    }}
                    classes={{
                        root: "text-white",
                        icon: "text-white"
                    }}
                >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="week">This Week</MenuItem>
                    <MenuItem value="monthly">Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                </Select>
                {filterType === "monthly" && (
                    <div className="month-picker-with-nav">
                        <IconButton 
                            size="small" 
                            onClick={this.onPrevMonth}
                            className="month-nav-button"
                        >
                            <KeyboardArrowLeftIcon />
                        </IconButton>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                views={["year", "month"]}
                                emptyLabel="..."
                                margin="none"
                                className="dark-datepicker slim-month-input"
                                value={startDate}
                                onChange={this.onChangeMonth}
                                format={monthFormat}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                autoOk
                                InputProps={{
                                    classes: {
                                        root: "text-white"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        <IconButton 
                            size="small" 
                            onClick={this.onNextMonth}
                            className="month-nav-button"
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                    </div>
                )}
                {filterType === "custom" && (
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            emptyLabel="From"
                            margin="none"
                            className="dark-datepicker slim-input"
                            value={startDate}
                            onChange={this.onChangeStartDate}
                            keyboardIcon={<EventIcon />}
                            leftArrowIcon={<KeyboardArrowLeftIcon />}
                            rightArrowIcon={<KeyboardArrowRightIcon />}
                            format={dateFormat}
                            InputProps={{
                                classes: {
                                    root: "text-white"
                                }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                )}
                {filterType === "custom" && (
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            emptyLabel="To"
                            margin="none"
                            className="dark-datepicker slim-input"
                            value={endDate}
                            onChange={this.onChangeEndDate}
                            format={dateFormat}
                            keyboardIcon={<EventIcon />}
                            leftArrowIcon={<KeyboardArrowLeftIcon />}
                            rightArrowIcon={<KeyboardArrowRightIcon />}
                            InputProps={{
                                classes: {
                                    root: "text-white"
                                }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                )}
            </>
        );
    };

    render() {
        const { filterSection } = this.props;
        // Observe profile availability so a late profile load starts the option requests.
        if (filterSection !== "date") {
            this.getProfileId();
        }
        
        if (filterSection === "entity") {
            return this.renderEntityFilters();
        }
        if (filterSection === "date") {
            return this.renderDateFilters();
        }
        
        return (
            <>
                {this.renderEntityFilters()}
                {this.renderDateFilters()}
            </>
        );
    }
}

export default AgentFilter;
